import React, { useState } from "react";
import MessageCard from "./MessageCard";
import ChatInput from "./ChatInput";
import Avatar from "@mui/material/Avatar";
import { Icon } from "@iconify/react/dist/iconify.js";
import CircularProgress from "@mui/material/CircularProgress";
import ConfirmationPopup from "../../general/ConfirmationPopup";
import { useAuth } from "../../../hooks/useAuth";
import moment from "moment";

export default function ChatWindow({
  chat,
  handleCross,
  messages,
  isLoadingMesssages,
  isSubmittingMsg,
  setIsSubmittingMsg,
}) {
  const [message, setMessage] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const { socket, userInfo } = useAuth();

  const handleEdit = (msg) => {
    setMessage(msg.content);
    setSelectedChat(msg);
    setIsUpdate(true);
  };

  const handleAgreeDelete = (msg) => {
    setSelectedChat(msg);
    setOpenDelete(true);
  };

  const handleDelete = () => {
    const socketData = {
      sender_id: userInfo.id,
      message_id: selectedChat.message_id,
    };
    console.log(socketData, "<= delete_message");
    socket.emit("delete_message", socketData);
    setOpenDelete(false);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setSelectedChat(null);
    setIsUpdate(false);
    setMessage("");
  };

  return (
    <>
      <div className="d-flex flex-column h-100 w-100">
        <div className="d-flex justify-content-between align-items-center chat-window-header p-3">
          <div className="d-flex align-items-center gap-2">
            <div className="conversation-avatar">
              <Avatar src={chat.avatar || undefined}>
                {chat.first_name?.[0] || "A"}
              </Avatar>
            </div>
            <div>
              <div className="fw-bold">{`${chat.first_name} ${chat.last_name}`}</div>

              <div className="text-muted small">
                {chat.is_online
                  ? "Active Now"
                  : chat.last_seen
                  ? `Last seen ${moment(chat.last_seen).fromNow()}`
                  : ""}
              </div>
            </div>
          </div>
          <button className="hide-chat" onClick={handleCross}>
            <Icon icon="bitcoin-icons:cross-filled" />
          </button>
        </div>
        <div
          className="flex-grow-1 overflow-auto p-3 chat-messages"
          id="chat-box-body"
        >
          {isLoadingMesssages && (
            <div className="messages-loader">
              <CircularProgress />
            </div>
          )}
          {messages.length === 0 ? (
            <div className="text-center p-5 no-chat-selected">
              <Icon icon="uiw:message" width="70" className="mb-4" />
              <h2 className="mb-3">{`Chat with ${chat.first_name} ${chat.last_name}`}</h2>
              <div>
                No messages yet. Start the conversation by sending your first
                message.
              </div>
            </div>
          ) : (
            messages.map((msg) => (
              <MessageCard
                key={msg.id}
                message={msg}
                handleEdit={handleEdit}
                handleAgreeDelete={handleAgreeDelete}
              />
            ))
          )}
        </div>
        <ChatInput
          {...{
            isSubmittingMsg,
            setIsSubmittingMsg,
            chat,
            message,
            setMessage,
            isUpdate,
            setIsUpdate,
            selectedChat,
            setSelectedChat,
            handleCancel,
          }}
        />
      </div>
      <ConfirmationPopup
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete this message?"}
        handleAgree={handleDelete}
      />
    </>
  );
}
